import { render, staticRenderFns } from "./drawer_remark.vue?vue&type=template&id=e5d4297a&scoped=true&"
import script from "./drawer_remark.vue?vue&type=script&lang=js&"
export * from "./drawer_remark.vue?vue&type=script&lang=js&"
import style0 from "./drawer_remark.vue?vue&type=style&index=0&id=e5d4297a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d4297a",
  null
  
)

export default component.exports